import { UPDATE_GCC_PRODUCT_DETAILS, APP_MOUNT } from '../actions/actionTypes';

export const initialState = {
  details: {
    attributes: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
  case UPDATE_GCC_PRODUCT_DETAILS:
    return { ...state, details: action.productDetails };
  case APP_MOUNT: {
    return {
      ...initialState,
    };
  }
  default:
    return state;
  }
};
